<template>
  <div class="menu-box">
    <div class="header-box">
      <header-back
        :title="$store.state.baseinfo.projectname"
        @back="resetHandler"
      />
      <div
        class="m-read-box"
        :class="{'no-read-num': !$store.state.baseinfo.unread_notice_num }"
      >
        <router-link
          v-if="$store.state.baseinfo.unread_notice_num"
          class="has-read-num"
          :to="{ name: 'recordNotice' }"
        >
          {{ $store.state.baseinfo.unread_notice_num * 1 > 99 ? '99+' : $store.state.baseinfo.unread_notice_num }}
        </router-link>
        <router-link
          v-else
          class="icon iconfont iconicon-test34"
          :to="{ name: 'recordNotice' }"
        />
      </div>
    </div>
    <ul v-if="menuList && menuList.length">
      <template v-for="item in menuList">
        <li
          v-if="item.show"
          :key="item.key"
          :class="{ active: item.active && !item.child }"
        >
          <div
            class="item clearfix"
            @click="handleChangeMenu(item, $event)"
          >
            <i
              class="iconfont"
              :class="`${item.mIconClass}`"
            />
            <span class="name">{{ item.name }}</span>
          </div>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import HeaderBack from '@/components/mobile/HeaderBack'
import { clearPid } from '@/lib/storage'
export default {
  components: {
    HeaderBack
  },
  computed: {
    ...mapState(['menuDatas', 'baseinfo']),
    isVisibleDialog () {
      return this.baseinfo.is_need_cost || false
    },
    pid () {
      return this.$store.state.pid || this.$route.params.pid
    },
    routeName () {
      return this.$route.name
    },
    menuLabels () {
      return this.menuDatas.menuLabels
    },
    permissionMenuList () {
      return this.menuDatas.permissionMenuList
    },
    // item.state && (item.key !== 'work-handover') && (item.key !== 'project-config') && (item.key !== 'notice-history') && (item.key === 'cost-maintenance' && baseinfo.vip)
    menuList () {
      let res = []
      for (let one of this.menuLabels) {
        let parent = JSON.parse(JSON.stringify(one))
        for (let j in this.permissionMenuList) {
          if (parent.key === j) {
            const item = this.permissionMenuList[j]

            // 设置父级菜单栏不展示的情况
            switch (parent.key) {
              case 'work-handover': // 离职交接
              case 'project-config': // 项目配置
              case 'notice-history': // 通知记录
              case 'universal-form': // 万能表单
              case 'email-direct-marketing': // EDM
              case 'clue-manage': // 线索管理
                parent.show = false
                break
              case 'cost-maintenance': // 成本维护
                if (item.state && this.baseinfo.vip) {
                  parent.show = true
                } else {
                  parent.show = false
                }
                break
              default:
                parent.show = item.state
                break
            }

            if (item.child) {
              parent.child = []
              for (let c in item.child) {
                parent.child.push({
                  key: c,
                  name: item.child[c].name,
                  active: false,
                  state: item.child[c].state
                })
              }
            }
          }
        }
        res.push(parent)
      }
      return res
    }
  },
  watch: {
    'baseinfo': {
      handler (val) {
        if (val && Object.keys(val).length) {
          document.title = this.$store.state.baseinfo.projectname + '-' + this.$store.state.baseinfo.comname
        }
      },
      deep: true
    }
  },
  async created () {
    await this.permissionMenu()

    this.isVisibleDialog && this.showCostDialog()
  },
  methods: {
    ...mapActions(['permissionMenu']),
    ...mapActions('costMaintain/costIndexData', ['cacelCostDialog']),
    ...mapActions(['setPid']),
    handleChangeMenu (item, event) {
      switch (item.key) {
        case 'statistics':
          this.$router.push({
            path: item.link
          })
          break
        case 'inquiry-audit':
        case 'inquiry-mine':
        case 'inquiry-all':
          let type, from
          let query = {}

          if (item.key === 'inquiry-all' || item.key === 'inquiry-audit') {
            from = 'all'
            if (item.key === 'inquiry-audit') {
              from = 'audit'
            }
            // 默认展示第一个
            if ((this.baseinfo.system_role === 4 || this.baseinfo.system_role === 5) && from === 'all') {
              type = this.setDefaultChooseType(this.baseinfo.system_role)
            } else if (item.child && item.child[0]) {
              type = item.child[0].key
            }
          } else if (item.key === 'inquiry-mine') {
            from = 'my'
            /* 设置默认选择的列表 */
            type = this.setDefaultChooseType(item)
          }

          query = { type, from }

          this.$router.push({
            name: item.routeName,
            query
          })
          break
        default:
          this.$router.push({
            name: item.routeName
          })
          break
      }
    },
    setDefaultChooseType (item) {
      let { system_role: systemRole } = this.baseinfo || {}
      let type = ''
      switch (systemRole) {
        case 3:
          // 默认选中：我开发的
          type = 'inquiry-dev'
          break
        case 4:
          // 默认选中：我录入的
          type = 'inquiry-add'
          break
        case 5:
          // 默认选中：我跟进的
          type = 'inquiry-followup'
          break
        default:
          // 默认展示第一个
          if (item.child && item.child[0]) {
            type = item.child[0].key
          }
          break
      }
      return type
    },
    resetHandler () {
      this.$store.commit('setDingding', '')
      this.setPid('')
      clearPid()
      this.$router.push({
        name: 'ProjectIndexPc',
        query: {
          page: 2,
          cid: this.$route.query.cid * 1 || this.$store.state.baseinfo.cid,
          type: 'inquery'
        }
      })
    },
    // 显示成本维护弹窗
    showCostDialog () {
      const _this = this
      _this.$createDialog({
        type: 'confirm',
        icon: '',
        title: this.$t('message["996"]'),
        content: this.$t('message["1097"]') + '？',
        confirmBtn: {
          text: this.$t('message["915"]'),
          active: true,
          disabled: false
        },
        cancelBtn: {
          text: this.$t('message["1004"]'),
          active: false,
          disabled: false
        },
        onConfirm: () => {
          _this.$router.push({
            path: `/project/${_this.pid}/cost/maintain`
          })
        },
        onCancel: () => {
          _this.cacelCostDialog()
        }
      }).show()
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-box::v-deep {
  ul {
    padding: 12px;
    li {
      padding: 16px 16px 16px 50px;
      background: #fff;
      border-radius: 4px;
      height: 24px;
      line-height: 24px;
      margin-bottom: 12px;
      box-sizing: content-box;
      position: relative;
      .name {
        line-height: 24px;
      }
      i {
        position: absolute;
        font-size: 24px;
        color: #42c27e;
        margin-right: 10px;
        left: 16px;
      }
      .iconicon-test3,
      .iconicon-test11 {
        color: #f6a953;
      }
      .iconicon-test6,
      .iconicon-test4 {
        color: #4ca0f2;
      }
      .iconicon-test5 {
        color: #f57676;
      }
    }
  }
  .header-box {
    position: relative;
    .m-read-box {
      position: fixed;
      right: 10px;
      top: 10px;
      z-index: 100;
      .iconicon-test34 {
        color: #ccc;
        font-size: 20px;
      }
      .has-read-num {
        display: inline-block;
        width: 26px;
        height: 26px;
        line-height: 26px;
        text-align: center;
        color: #fff;
        font-size: 12px;
        font-style: normal;
        background: #f57676;
        border-radius: 50%;
      }
    }
    .no-read-num {
      top: 13px;
    }
  }
}
</style>
<style lang="scss">
.cube-dialog-btn {
  color: #333;
}
.cube-dialog-btn_highlight {
  color: #5077aa;
}
</style>
